export default __webpack_public_path__ + "static/media/checkmark.48c6b08d.svg";